export function getDBDateFromMomentObject(date) {
  return date.format('yyyy-MM-DD');
}
